const RELOAD_KEY = 'preload-reload-build';

// Set while a reload is in flight, so the root error boundary can show a loading state
// instead of flashing the error UI for the brief window before the page reloads.
// In-memory by design: the fresh load after the reload starts with a clean false.
let reloadPending = false;

export const isPreloadReloadPending = () => reloadPending;

// After a deploy the content-hashed chunks change, so a tab on the old build 404s when
// it lazy-loads a chunk. Reload once to pick up fresh asset references. Guarding on
// __BUILD_ID__ stops a reload loop when the deploy itself is broken: a second failure
// on the same build lets the error surface to the root error boundary.
export const registerPreloadErrorHandler = () => {
  window.addEventListener('vite:preloadError', (event) => {
    if (sessionStorage.getItem(RELOAD_KEY) === __BUILD_ID__) return;

    event.preventDefault();
    sessionStorage.setItem(RELOAD_KEY, __BUILD_ID__);

    reloadPending = true;

    window.location.reload();
  });
};
